import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import TextEditorVideoEmbedForm from '../../components/text-editor-video-embed-form';
import { closeModal } from '../../actions/close-modal';

const TextEditEditorVideoEmbedModal = ({ insertTextEditorVideoEmbed, closeModal }) =>
  <Modal backdrop={true} onClose={closeModal}>
    <TextEditorVideoEmbedForm onSubmit={insertTextEditorVideoEmbed} onCancel={closeModal}/>
  </Modal>;

TextEditEditorVideoEmbedModal.propTypes = {
  insertTextEditorVideoEmbed: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  identifier: PropTypes.string.isRequired,
};

const mapDispatchToProps = (dispatch, { identifier }) =>
  bindActionCreators(
    {
      insertTextEditorVideoEmbed: data =>
        closeModal({
          identifier,
          ...data,
        }),
      closeModal,
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(TextEditEditorVideoEmbedModal);



// WEBPACK FOOTER //
// ./app/containers/text-editor-video-embed-modal/text-editor-video-embed-modal.js